import React from 'react';
import CatalogPage from '../../components/CatalogPage/CatalogPage';
import { refletorService } from '../../services/api';

const RefletorRegistration: React.FC = () => (
  <CatalogPage
    title="Refletores"
    subtitle="Cadastre e gerencie os modelos de refletores disponíveis no checklist de conclusão."
    listTitle="Refletores cadastrados"
    listDescription="Estes modelos aparecerão no campo Refletor instalado do checklist mobile."
    placeholder="Nome do refletor (ex: LED 200W)"
    service={refletorService}
  />
);

export default RefletorRegistration;
